import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { initializeApp, getApps } from "firebase/app";
import { getAuth, isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import { auth as primaryAuth } from "../components/firebase";
import { sanitizeEmail } from "../lib/sanitize";

const PROJECT = process.env.REACT_APP_FIREBASE_PROJECT_ID;
const REGION = "europe-west3";
const CF_BASE = process.env.REACT_APP_CF_BASE || `https://${REGION}-${PROJECT}.cloudfunctions.net`;

const KEY = "pp_emailAttach_email";

// отдельный app/auth чтобы не трогать wallet-сессию
function getEmailAttachAuth() {
  const existing = getApps().find(a => a.name === "emailAttachApp");
  const app = existing || initializeApp(primaryAuth.app.options, "emailAttachApp");
  return getAuth(app);
}

export default function FinishEmailAttach() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const attachToken = params.get("token") || "";
  const emailFromUrl = params.get("email") || "";

  const [msg, setMsg] = useState("Finishing email verification...");
  const [needEmail, setNeedEmail] = useState(false);
  const [email, setEmail] = useState("");

  const complete = async (emailOverride) => {
    try {
      if (!attachToken) {
        setMsg("Missing token.");
        return;
      }

      const emailAuth = getEmailAttachAuth();
      const href = window.location.href;

      if (!isSignInWithEmailLink(emailAuth, href)) {
        setMsg("This link is not valid here.");
        return;
      }

      const emailFromUrl = params.get("email") || "";

const em = sanitizeEmail(
  emailOverride || emailFromUrl || window.localStorage.getItem(KEY) || ""
);


      if (!em) {
        setNeedEmail(true);
        setMsg("Enter the email you used to request the link:");
        return;
      }

      setNeedEmail(false);
      setMsg("Verifying...");

      const cred = await signInWithEmailLink(emailAuth, em, href);
      const user = cred.user;

      const idToken = await user.getIdToken(true);

      const r = await fetch(`${CF_BASE}/confirmEmailAttach`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify({ attachToken }),
      });

      const text = await r.text().catch(() => "");
      if (!r.ok) throw new Error(text || `confirmEmailAttach failed (${r.status})`);

      window.localStorage.removeItem(KEY);

      setMsg("Email verified ✅ You can return to the app.");
      setTimeout(() => nav("/profile?tab=settings", { replace: true }), 1200);
    } catch (e) {
      setMsg(e?.message || "Email attach failed");
    }
  };

  useEffect(() => { complete(); /* eslint-disable-next-line */ }, []);

  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", bgcolor: "#070b12" }}>
      <Box sx={{ width: "min(520px, 92vw)", p: 3, borderRadius: 3, border: "1px solid rgba(255,255,255,.10)", bgcolor: "rgba(18,22,28,.72)", color: "#e5e7eb" }}>
        <Typography fontWeight={900} mb={1}>PromosPay</Typography>
        <Typography sx={{ opacity: 0.8, mb: needEmail ? 2 : 0 }}>{msg}</Typography>

        {needEmail && (
          <>
            <TextField
              fullWidth
              size="small"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button
              sx={{ mt: 2, borderRadius: 2, fontWeight: 900, textTransform: "none" }}
              variant="contained"
              onClick={() => complete(email)}
              disabled={!email.includes("@")}
            >
              Continue
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
}
